var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "stadiafr-jeux-login" } },
    [
      _vm.is_loading
        ? [_c("Loader")]
        : [
            _c("div", { staticClass: "logo" }),
            _vm._v(" "),
            _c("div", { staticClass: "wordings" }, [
              _vm._v(
                "\n            Vous devez vous connecter avec votre compte Discord pour accéder aux Stadia Fr Awards.\n        "
              )
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/public/assets/images/discord-logo.png" },
              on: { click: _vm.discordLogo_clicked }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }